var map = {
	"./common/WrappedToken/abi.json": 1230,
	"./common/erc20/abi.json": 1231,
	"./common/iNFTspaceINSToken/abi.json": 1232,
	"./common/iNFTspaceUSDTToken/abi.json": 1233,
	"./market/v28/abi.json": 1234,
	"./mystery/v25/abi.json": 1235,
	"./mystery/v26/abi.json": 1236,
	"./payment/v27/abi.json": 1237,
	"./sale/v26/abi.json": 1238,
	"./transaction/v27/abi.json": 1239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1229;